import { Component, Input } from '@angular/core';
import { RoleMatrix } from 'src/helpers';

@Component({
    selector: 'app-breadcrumb-user-group-detail',
    templateUrl: './breadcrumb.user.group.detail.component.html'
})

export class BreadcrumbUserGroupDetailComponent {
    @Input() companyId: number;
    roleMatrix: RoleMatrix;

    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}
